import { render, staticRenderFns } from "./GameKefu.vue?vue&type=template&id=7c88334e&"
import script from "./GameKefu.vue?vue&type=script&lang=js&"
export * from "./GameKefu.vue?vue&type=script&lang=js&"
import style0 from "./GameKefu.vue?vue&type=style&index=0&lang=less&scope=true&"
import style1 from "./GameKefu.vue?vue&type=style&index=1&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports